import http from 'hub-http/clients/apiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getActiveProcessorAccountsRpc } from '../../__generated__/chirp/com/hubspot/payments/accounts/rpc/ProcessorAccountReadService';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export function fetch() {
  return rpcClient.call(getActiveProcessorAccountsRpc, {});
}